export function getItem(key: string) {
    return localStorage.getItem(key);
}

export function getItemAsJson(key: string) {
    return JSON.parse(getItem(key));
}

export function setItem(key: string, item: any): void {
    return localStorage.setItem(key, item);
}

export function setItemAsJson(key: string, item: any): void {
    return setItem(key, JSON.stringify(item));
}

export function getItemFromSessionStorage(key: string) {
    return sessionStorage.getItem(key);
}

export function setItemInSessionStorage(key: string, item: any) {
    return sessionStorage.setItem(key, item);
}

const userLocalStorageKey = 'user';
const auth0SpaJsKeySubstring = 'auth0spajs';

/**
 * Removes every localStorage entry except the platform user (`user`) and
 * Auth0 SPA JS cache keys (those containing `auth0spajs`).
 */
export function clearLocalStorageExceptUserAndAuth0Spajs(): void {
    const preserved: { key: string; value: string }[] = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key) {
            continue;
        }
        if (key === userLocalStorageKey || key.includes(auth0SpaJsKeySubstring)) {
            preserved.push({ key, value: localStorage.getItem(key) ?? '' });
        }
    }
    localStorage.clear();
    for (const { key, value } of preserved) {
        localStorage.setItem(key, value);
    }
}
